export default {
  name: 'overlay',
  namespaced: true,
  state: {
    overlay: null,
    properties: null,
  },
  getters: {
    isShowOverlay(state) {
      return state.overlay !== null
    },
    getOverlay(state) {
      return state.overlay
    },
    getProps(state) {
      return state.properties
    },
  },
  mutations: {
    setOverlay(state, v) {
      state.overlay = v
    },
    setProps(state, v) {
      state.properties = v
    },
  },
  actions: {
    closeOverlay({ commit }) {
      commit('setOverlay', null)
    },
    openOverlay({ commit }, overlayKey) {
      commit('setOverlay', overlayKey)
    },
    passProps({ commit }, props) {
      commit('setProps', props)
    },
  },
}
